module.exports = __webpack_public_path__ + "static/media/java.f79b0cc0.svg";